export default "__VITE_ASSET__DTZoiH_2__"